<template>
    <div class="achAssessCell">
        <!-- <RadioGroup >
            <Radio label="十五宫格人员"></Radio>
            <Radio label="十五宫格占比"></Radio>
        </RadioGroup> -->
        <div style="margin-top:30px">
            <Card style="width:100%;">
                <Row class="patentialRow" v-for="(item,index) in data" :key="index">
                    <Col span="2">
                    <span>{{lang=='zh'?item.scopeType:item.enScopeType}}</span>
                    </Col>
                    <Col span="4">
                        <div class="potentialBox" :class="index==0||index==1?'potentialBoxBackground1':'potentialBoxBackground4'" >
                            <div v-if="item.peopleNameList1.length>0">
                                <Poptip v-model="item1.visible" popper-class="popClass" placement="right" width="300px" v-for="(item1,index1) in item.peopleNameList1" :key="index1" transfer>
                                    <Button type="primary" size="small" style="margin:2px">{{lang=="zh"?item1.userName:item1.userEName}}</Button>
                                    <div class="poptipContent" slot="content">
                                    <div style="display:flex;align-items: center;">
                                        <h2 style="color:black">{{item1.userName}}</h2>
                                        <h2 style="color:#666666;margin-left:15px">{{item1.userEName}}</h2>
                                        <span style="margin-left:15px" v-if="item1.beT1Successor>0"><Tag>T1继任</Tag></span>
                                    </div>
                                        <div style="display:flex;flex-wrap: wrap;">
                                            <Form :label-width="120" label-position="left">
                                            <Row >
                                              <Col span="24">
                                                <FormItem :label="$t('Talent Tag')"><!-- 人才标签 -->
                                                    <Tag color="primary" v-for="(el,index) in item1.abilityList" :key="index">{{el.ability}}</Tag>
                                                </FormItem>
                                              </Col>
                                              <Col span="24" ><!-- 离职风险 -->
                                                <FormItem :label="$t('Attrition_Risk')"><Tag v-if="item1.exitRiskCode" :color="tabColor(item1.exitRiskCode)"> {{item1.exitRisk}} </Tag></FormItem>
                                              </Col>
                                              <Col span="24">
                                                <FormItem :label="$t('Mobility')"> {{item1.crossRegion}}</FormItem><!-- 能动性 -->
                                              </Col>
                                              <Col span="24">
                                                <FormItem :label="$t('WHAT_Assessment_PPT')"><!-- WHAT评分 -->
                                                    <Select v-model="item1.whatScore" clearable  transfer :disabled="selectCheck(item1)"  @on-change="targetItemChange1(item1,index,index1)" style="width:160px">
                                                        <Option v-for="item in Score" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                                    </Select>
                                                </FormItem>
                                              </Col>
                                              <Col span="24">
                                                <FormItem :label="$t('HOW_Assessment_PPT')"><!-- HOW评分 -->
                                                    <Select v-model="item1.howScore" clearable  transfer :disabled="selectCheck(item1)" @on-change="targetItemChange1(item1,index,index1)"  style="width:160px">
                                                        <Option v-for="item in Score" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                                    </Select>
                                                </FormItem>
                                              </Col>
                                              <Col span="24">
                                               <FormItem :label="$t('Overall_Assessment_PPT')"><!-- Overall评分 -->
                                                    <Select v-model="item1.wholeScore" clearable  transfer disabled style="width:160px">
                                                        <Option v-for="item in Score" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                                    </Select>
                                                </FormItem>
                                              </Col>
                                              <Col span="24">
                                               <FormItem :label="$t('Potential_Rating')"><!-- 潜能评分 -->
                                                    <Select v-model="item1.potentialScore" clearable  transfer :disabled="selectCheck(item1)" style="width:160px">
                                                        <Option v-for="item in PotentialScore" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                                    </Select>
                                                </FormItem>
                                              </Col>
                                              <Col span="24">
                                                <Button v-if="!selectCheck(item1)" @click="saveitem(item1)"><!-- 保存 -->{{$t('Save')}}</Button>
                                              </Col>
                                            </Row>
                                            </Form>
                                        </div>
                                    </div>
                                </Poptip>
                            </div>
                            <div v-else>0</div>
                        </div>
                    </Col>
                    <Col span="4">
                        <div class="potentialBox" :class="index==0||index==1?'potentialBoxBackground1':'potentialBoxBackground4'" >
                            <div v-if="item.peopleNameList2.length>0">
                                <Poptip v-model="item1.visible" popper-class="popClass" placement="right" width="300px" v-for="(item1,index1) in item.peopleNameList2" :key="index1" transfer>
                                    <Button type="primary" size="small" style="margin:2px">{{lang=="zh"?item1.userName:item1.userEName}}</Button>
                                    <div class="poptipContent" slot="content">
                                    <div style="display:flex;align-items: center;">
                                        <h2 style="color:black">{{item1.userName}}</h2>
                                        <h2 style="color:#666666;margin-left:15px">{{item1.userEName}}</h2>
                                        <span style="margin-left:15px" v-if="item1.beT1Successor>0"><Tag>T1继任</Tag></span>
                                    </div>
                                        <div style="display:flex;flex-wrap: wrap;">
                                            <Form :label-width="120" label-position="left">
                                            <Row >
                                              <Col span="24">
                                                <FormItem :label="$t('Talent Tag')"><!-- 人才标签 -->
                                                    <Tag color="primary" v-for="(el,index) in item1.abilityList" :key="index">{{el.ability}}</Tag>
                                                </FormItem>
                                              </Col>
                                              <Col span="24" ><!-- 离职风险 -->
                                                <FormItem :label="$t('Attrition_Risk')"><Tag v-if="item1.exitRiskCode" :color="tabColor(item1.exitRiskCode)"> {{item1.exitRisk}} </Tag></FormItem>
                                              </Col>
                                              <Col span="24">
                                                <FormItem :label="$t('Mobility')"> {{item1.crossRegion}}</FormItem><!-- 能动性 -->
                                              </Col>
                                               <Col span="24">
                                                <FormItem :label="$t('WHAT_Assessment_PPT')"><!-- WHAT评分 -->
                                                    <Select v-model="item1.whatScore" clearable  transfer :disabled="selectCheck(item1)"  @on-change="targetItemChange2(item1,index,index1)" style="width:160px">
                                                        <Option v-for="item in Score" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                                    </Select>
                                                </FormItem>
                                              </Col>
                                              <Col span="24">
                                                <FormItem :label="$t('HOW_Assessment_PPT')"><!-- HOW评分 -->
                                                    <Select v-model="item1.howScore" clearable  transfer :disabled="selectCheck(item1)"  @on-change="targetItemChange2(item1,index,index1)" style="width:160px">
                                                        <Option v-for="item in Score" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                                    </Select>
                                                </FormItem>
                                              </Col>
                                              <Col span="24">
                                               <FormItem :label="$t('Overall_Assessment_PPT')"><!-- Overall评分 -->
                                                    <Select v-model="item1.wholeScore" clearable  transfer disabled style="width:160px">
                                                        <Option v-for="item in Score" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                                    </Select>
                                                </FormItem>
                                              </Col>
                                              <Col span="24">
                                               <FormItem :label="$t('Potential_Rating')"><!-- 潜能评分 -->
                                                    <Select v-model="item1.potentialScore" clearable  transfer :disabled="selectCheck(item1)" style="width:160px">
                                                        <Option v-for="item in PotentialScore" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                                    </Select>
                                                </FormItem>
                                              </Col>
                                              <Col span="24">
                                                <Button v-if="!selectCheck(item1)" @click="saveitem(item1)"><!-- 保存 -->{{$t('Save')}}</Button>
                                              </Col>
                                            </Row>
                                            </Form>
                                        </div>
                                    </div>
                                </Poptip>
                            </div>
                            <div v-else>0</div>
                        </div>
                    </Col>
                    <Col span="4">
                        <div class="potentialBox" :class="index==0?'potentialBoxBackground2':index==1?'potentialBoxBackground3':'potentialBoxBackground5'" >
                            <div v-if="item.peopleNameList3.length>0">
                                <Poptip v-model="item1.visible" popper-class="popClass" placement="right" width="300px" v-for="(item1,index1) in item.peopleNameList3" :key="index1" transfer>
                                    <Button type="primary" size="small" style="margin:2px">{{lang=="zh"?item1.userName:item1.userEName}}</Button>
                                    <div class="poptipContent" slot="content">
                                    <div style="display:flex;align-items: center;">
                                        <h2 style="color:black">{{item1.userName}}</h2>
                                        <h2 style="color:#666666;margin-left:15px">{{item1.userEName}}</h2>
                                        <span style="margin-left:15px" v-if="item1.beT1Successor>0"><Tag>T1继任</Tag></span>
                                    </div>
                                        <div style="display:flex;flex-wrap: wrap;">
                                            <Form :label-width="120" label-position="left">
                                            <Row >
                                              <Col span="24">
                                                <FormItem :label="$t('Talent Tag')"><!-- 人才标签 -->
                                                    <Tag color="primary" v-for="(el,index) in item1.abilityList" :key="index">{{el.ability}}</Tag>
                                                </FormItem>
                                              </Col>
                                              <Col span="24" ><!-- 离职风险 -->
                                                <FormItem :label="$t('Attrition_Risk')"><Tag v-if="item1.exitRiskCode" :color="tabColor(item1.exitRiskCode)"> {{item1.exitRisk}} </Tag></FormItem>
                                              </Col>
                                              <Col span="24">
                                                <FormItem :label="$t('Mobility')"> {{item1.crossRegion}}</FormItem><!-- 能动性 -->
                                              </Col>
                                              <Col span="24">
                                                <FormItem :label="$t('WHAT_Assessment_PPT')"><!-- WHAT评分 -->
                                                    <Select v-model="item1.whatScore" clearable  transfer :disabled="selectCheck(item1)"  @on-change="targetItemChange3(item1,index,index1)" style="width:160px">
                                                        <Option v-for="item in Score" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                                    </Select>
                                                </FormItem>
                                              </Col>
                                              <Col span="24">
                                                <FormItem :label="$t('HOW_Assessment_PPT')"><!-- HOW评分 --> 
                                                    <Select v-model="item1.howScore" clearable  transfer :disabled="selectCheck(item1)"  @on-change="targetItemChange3(item1,index,index1)" style="width:160px">
                                                        <Option v-for="item in Score" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                                    </Select>
                                                </FormItem>
                                              </Col>
                                              <Col span="24">
                                               <FormItem :label="$t('Overall_Assessment_PPT')"><!-- Overall评分 -->
                                                    <Select v-model="item1.wholeScore" clearable  transfer disable style="width:160px">
                                                        <Option v-for="item in Score" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                                    </Select>
                                                </FormItem>
                                              </Col>
                                              <Col span="24">
                                               <FormItem :label="$t('Potential_Rating')"><!-- 潜能评分 -->
                                                    <Select v-model="item1.potentialScore" clearable  transfer :disabled="selectCheck(item1)" style="width:160px">
                                                        <Option v-for="item in PotentialScore" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                                    </Select>
                                                </FormItem>
                                              </Col>
                                              <Col span="24">
                                                <Button v-if="!selectCheck(item1)" @click="saveitem(item1)"><!-- 保存 -->{{$t('Save')}}</Button>
                                              </Col>
                                            </Row>
                                            </Form>
                                        </div>
                                    </div>
                                </Poptip>
                            </div>
                            <div v-else>0</div>
                        </div>
                    </Col>
                    <Col span="4">
                        <div class="potentialBox" :class="index==0?'potentialBoxBackground2':index==1?'potentialBoxBackground3':'potentialBoxBackground5'" >
                            <div v-if="item.peopleNameList4.length>0">
                                <Poptip v-model="item1.visible" popper-class="popClass" placement="right" width="300px" v-for="(item1,index1) in item.peopleNameList4" :key="index1" transfer>
                                    <Button type="primary" size="small" style="margin:2px">{{lang=="zh"?item1.userName:item1.userEName}}</Button>
                                    <div class="poptipContent" slot="content">
                                    <div style="display:flex;align-items: center;">
                                        <h2 style="color:black">{{item1.userName}}</h2>
                                        <h2 style="color:#666666;margin-left:15px">{{item1.userEName}}</h2>
                                        <span style="margin-left:15px" v-if="item1.beT1Successor>0"><Tag>T1继任</Tag></span>
                                    </div>
                                        <div style="display:flex;flex-wrap: wrap;">
                                            <Form :label-width="120" label-position="left">
                                            <Row >
                                              <Col span="24">
                                                <FormItem :label="$t('Talent Tag')"><!-- 人才标签 -->
                                                    <Tag color="primary" v-for="(el,index) in item1.abilityList" :key="index">{{el.ability}}</Tag>
                                                </FormItem>
                                              </Col>
                                              <Col span="24" ><!-- 离职风险 -->
                                                <FormItem :label="$t('Attrition_Risk')"><Tag v-if="item1.exitRiskCode" :color="tabColor(item1.exitRiskCode)"> {{item1.exitRisk}} </Tag></FormItem>
                                              </Col>
                                              <Col span="24">
                                                <FormItem :label="$t('Mobility')"> {{item1.crossRegion}}</FormItem><!-- 能动性 -->
                                              </Col>
                                              <Col span="24">
                                                <FormItem :label="$t('WHAT_Assessment_PPT')"><!-- WHAT评分 -->
                                                    <Select v-model="item1.whatScore" clearable  transfer :disabled="selectCheck(item1)"  @on-change="targetItemChange4(item1,index,index1)" style="width:160px">
                                                        <Option v-for="item in Score" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                                    </Select>
                                                </FormItem>
                                              </Col>
                                              <Col span="24">
                                                <FormItem :label="$t('HOW_Assessment_PPT')"><!-- HOW评分 -->
                                                    <Select v-model="item1.howScore" clearable  transfer :disabled="selectCheck(item1)"   @on-change="targetItemChange4(item1,index,index1)" style="width:160px">
                                                        <Option v-for="item in Score" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                                    </Select>
                                                </FormItem>
                                              </Col>
                                              <Col span="24">
                                               <FormItem :label="$t('Overall_Assessment_PPT')"><!-- Overall评分 -->
                                                    <Select v-model="item1.wholeScore" clearable  transfer disabled style="width:160px">
                                                        <Option v-for="item in Score" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                                    </Select>
                                                </FormItem>
                                              </Col>
                                              <Col span="24">
                                               <FormItem :label="$t('Potential_Rating')"><!-- 潜能评分 -->
                                                    <Select v-model="item1.potentialScore" clearable  transfer :disabled="selectCheck(item1)" style="width:160px">
                                                        <Option v-for="item in PotentialScore" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                                    </Select>
                                                </FormItem>
                                              </Col>
                                              <Col span="24">
                                                <Button v-if="!selectCheck(item1)" @click="saveitem(item1)"><!-- 保存 -->{{$t('Save')}}</Button>
                                              </Col>
                                            </Row>
                                            </Form>
                                        </div>
                                    </div>
                                </Poptip>
                            </div>
                            <div v-else>0</div>
                        </div>
                    </Col>
                    <Col span="4">
                        <div class="potentialBox potentialBoxRight" :class="index==0?'potentialBoxBackground2':index==1?'potentialBoxBackground3':'potentialBoxBackground5 potentialBoxBottom'" >
                            <div v-if="item.peopleNameList5.length>0">
                                <Poptip v-model="item1.visible" popper-class="popClass" :placement="index==0?'bottom':'right'" width="300px" v-for="(item1,index1) in item.peopleNameList5" :key="index1" transfer>
                                    <Button type="primary" size="small" style="margin:2px">{{lang=="zh"?item1.userName:item1.userEName}}</Button>
                                    <div class="poptipContent" slot="content">
                                    <div style="display:flex;align-items: center;">
                                        <h2 style="color:black">{{item1.userName}}</h2>
                                        <h2 style="color:#666666;margin-left:15px">{{item1.userEName}}</h2>
                                        <span style="margin-left:15px" v-if="item1.beT1Successor>0"><Tag>T1继任</Tag></span>
                                    </div>
                                        <div style="display:flex;flex-wrap: wrap;">
                                            <Form :label-width="120" label-position="left">
                                            <Row >
                                              <Col span="24">
                                                <FormItem :label="$t('Talent Tag')"><!-- 人才标签 -->
                                                    <Tag color="primary" v-for="(el,index) in item1.abilityList" :key="index">{{el.ability}}</Tag>
                                                </FormItem>
                                              </Col>
                                              <Col span="24" ><!-- 离职风险 -->
                                                <FormItem :label="$t('Attrition_Risk')"><Tag v-if="item1.exitRiskCode" :color="tabColor(item1.exitRiskCode)"> {{item1.exitRisk}} </Tag></FormItem>
                                              </Col>
                                              <Col span="24">
                                                <FormItem :label="$t('Mobility')"> {{item1.crossRegion}}</FormItem><!-- 能动性 -->
                                              </Col>
                                              <Col span="24">
                                                <FormItem :label="$t('WHAT_Assessment_PPT')"><!-- WHAT评分 -->
                                                    <Select v-model="item1.whatScore" clearable  transfer :disabled="selectCheck(item1)"  @on-change="targetItemChange5(item1,index,index1)" style="width:160px">
                                                        <Option v-for="item in Score" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                                    </Select>
                                                </FormItem>
                                              </Col>
                                              <Col span="24">
                                                <FormItem :label="$t('HOW_Assessment_PPT')"><!-- HOW评分 -->
                                                    <Select v-model="item1.howScore" clearable  transfer :disabled="selectCheck(item1)"   @on-change="targetItemChange5(item1,index,index1)" style="width:160px">
                                                        <Option v-for="item in Score" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                                    </Select>
                                                </FormItem>
                                              </Col>
                                              <Col span="24">
                                               <FormItem :label="$t('Overall_Assessment_PPT')"><!-- Overall评分 -->
                                                    <Select v-model="item1.wholeScore" clearable  transfer disabled style="width:160px">
                                                        <Option v-for="item in Score" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                                    </Select>
                                                </FormItem>
                                              </Col>
                                              <Col span="24">
                                               <FormItem :label="$t('Potential_Rating')"><!-- 潜能评分 -->
                                                    <Select v-model="item1.potentialScore" clearable  transfer :disabled="selectCheck(item1)" style="width:160px">
                                                        <Option v-for="item in PotentialScore" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                                    </Select>
                                                </FormItem>
                                              </Col>
                                              <Col span="24">
                                                <Button v-if="!selectCheck(item1)" @click="saveitem(item1)"><!-- 保存 -->{{$t('Save')}}</Button>
                                              </Col>
                                            </Row>
                                            </Form>
                                        </div>
                                    </div>
                                </Poptip>
                            </div>
                            <div v-else>0</div>
                        </div>
                    </Col>
                </Row>
                <Row class="patentialRow">
                    <Col span="2"></Col>
                    <Col span="4">{{$t('PB_Requires_Improvement')}}</Col><!-- 需要改善 -->
                    <Col span="4">{{$t('PB-Typically_Meets')}}</Col><!-- 部分达标 -->
                    <Col span="4">{{$t('PB-Achieved')}}</Col><!-- 达到要求 -->
                    <Col span="4">{{$t('PB-Exceeds')}}</Col><!-- 超越要求 -->
                    <Col span="4">{{$t('PB-Exceptional')}}</Col><!-- 优秀出色 -->
                </Row>
            </Card>
        </div>
    </div>
</template>

<script>
import axios from "axios";
export default {
    data(){
        return{
            userList:[],
            data:[],
            selsetDisabled:false,
            Score:[],
            PotentialScore:[],
            beEnd:'',
            visible:false,
            overallScoreList:[]
        }
    },
    computed:{
        lang(){
            return this.$store.getters.selectLangeData
        }
    },
    methods:{
        targetItemChange1(item1,index,index1){
            if(item1.whatScore &&  item1.howScore){
                this.$set(this.data[index].peopleNameList1[index1], 'wholeScore', this.getOverallScore(item1.whatScore , item1.howScore));
            }
        },
        targetItemChange2(item1,index,index1){
            if(item1.whatScore &&  item1.howScore){
                this.$set(this.data[index].peopleNameList2[index1], 'wholeScore', this.getOverallScore(item1.whatScore , item1.howScore));
            }
        },
        targetItemChange3(item1,index,index1){
            if(item1.whatScore &&  item1.howScore){
                this.$set(this.data[index].peopleNameList3[index1], 'wholeScore', this.getOverallScore(item1.whatScore , item1.howScore));
            }
        },
        targetItemChange4(item1,index,index1){
            if(item1.whatScore &&  item1.howScore){
                this.$set(this.data[index].peopleNameList4[index1], 'wholeScore', this.getOverallScore(item1.whatScore , item1.howScore));
            }
        },
        targetItemChange5(item1,index,index1){
            if(item1.whatScore &&  item1.howScore){
                this.$set(this.data[index].peopleNameList5[index1], 'wholeScore', this.getOverallScore(item1.whatScore , item1.howScore));
            }
        },
        getOverallScore(whatScore,howScore){
            let overallScore = "";
            this.overallScoreList.forEach(res=>{
            if(whatScore == res.whatScore && howScore == res.howScore){
                overallScore =  res.overallScore
                }
            })  
            return overallScore
        },
        saveitem(item){
            if(!this.checkScore(item)){
                this.$Modal.confirm({
                title: `${item.userName}员工（${item.empCode}）的评分不符合规则，确认是否提交？`,
                onOk: () => {
                    axios.post('/AchPeopleBoard/saveFifteenPeopleBoardScore', item).then(res => {
                        if (res) {
                        this.$Message.success(this.$t('Save_Successful'));
                        this.$emit('saveScore')
                        item.visible=false
                        }
                    });
                }
              })
            }else {
                axios.post('/AchPeopleBoard/saveFifteenPeopleBoardScore', item).then(res => {
                    if (res) {
                    this.$Message.success(this.$t('Save_Successful'));
                    this.$emit('saveScore')
                    item.visible=false
                    }
                });
            }
            
        },
        checkScore(item){
            // let wholeScore=Number(item.wholeScore)
            // let whatScore=Number(item.whatScore)
            // let howScore=Number(item.howScore)
            // // Overall分数不大于What或How的单项分数
            // // 当What和How的分数差异大于1时，Overall的分数需在What和How的分数中间
            // if(wholeScore>whatScore&&wholeScore>howScore){
            //     console.log(111)
            //     return false
            // }else if(((whatScore-howScore)>1) && (wholeScore>=whatScore||wholeScore<=howScore)){
            //     console.log(222)
            //     return false
            // }else if(((howScore-whatScore)>1) && (wholeScore>=howScore||wholeScore<=whatScore)){
            //     return false
            // }
            return true
        },
        randomRgb() {
                let R = Math.floor(Math.random() * 255);
                let G = Math.floor(Math.random() * 255);
                let B = Math.floor(Math.random() * 255);
                return "rgb("+ R + "," + G + "," + B + ")";
            },
        tabColor(val){
            if(val=='H')return '#C66B5F'
            else if(val=='L') return '#5AA066'
            else if(val=='M') return '#CD9153'
        },
        selectCheck(el){
            let value = true
            if(el.endStatus){
              if( el.endStatus == '0' || el.beFlag == '0' || el.beCanUpdate == '1'){
                value=true
              }
            }else if(this.beEnd) {
                if(this.beEnd=='1'){
                    value=true
                }else {
                    value=false
                }
            }else {
                el.disabledFlag=='1'?value=true:value=false
            }
            return value
        },

    }
}
</script>

<style lang="less" scoped>
.patentialRow {
    margin-top: 0px;
    display: flex;
    align-items: center;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    span{
        display: block;
        text-align: right;
       margin-right: 20px;
    }
}

.potentialBox {
    width: 100%;
    height: 180px;
    border-top: 1px solid #cccccc;
    border-left: 1px solid #cccccc;
    border-radius: 0px;
    display: flex;
    flex-wrap: wrap;
    cursor: pointer;
    font-size: 22px;
    padding: 5px;
    box-sizing: border-box;
    overflow-y: auto;
}
.potentialBoxRight {
    border-right: 1px solid #cccccc;
}
.potentialBoxBottom {
    border-bottom: 1px solid #cccccc;
}

.potentialBoxBackground1 {
    background-image: linear-gradient(45deg,#dfdfdf 25%,white 0,white 50%,#dfdfdf 0,#dfdfdf 75%,white 0);
    background-size: 6px 6px;
}
.potentialBoxBackground2 {
   background-color: rgb(0, 50, 30);
   color: white;
}
.potentialBoxBackground3 {
    background-color: rgb(23, 177, 105);
}
.potentialBoxBackground4 {
   background-color: rgb(255, 180, 0);
}
.potentialBoxBackground5 {
    background-color: rgb(180, 145, 50);
}
.poptipContent {
    display: flex;
    flex-direction: column;
    text-align: left;
}
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
  background: #4ea397;
}
::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
  border-radius: 10px;
  background: #ededed;
}
/deep/.ivu-form-item {
    margin-bottom: 10px !important;
}

</style>
<style >
.popClass {
    width: 360px;
}
</style>


// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/AchAssessComponentCell.vue